module.exports = __webpack_public_path__ + "img/icon_1_49.01fc563d.png";